{
  "CANNED_MGMT": {
    "HEADER": "Canned Responses",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "There are no items matching this query.",
    "LIST": {
      "404": "There are no canned responses available in this account.",
      "TITLE": "Manage canned responses",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Content",
        "INBOXES": "Nabiralniki",
        "ACTIONS": "Actions"
      },
      "ALL_INBOXES": "Vsi nabiralniki",
      "FILTER": {
        "ALL_INBOXES": "Vsi nabiralniki",
        "NO_INBOX": "Brez nabiralnika",
        "SEARCH_PLACEHOLDER": "Iskanje nabiralnikov"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Zadeva (samo e-pošta)",
          "PLACEHOLDER": "Neobvezna zadeva za e-poštne odgovore / nove pogovore"
        },
        "CONTENT": {
          "LABEL": "Sporočilo",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Priloge"
        },
        "INBOXES": {
          "LABEL": "Nabiralniki",
          "PLACEHOLDER": "Izberite nabiralnike (neobvezno, pustite prazno za vse nabiralnike)"
        },
        "SUBMIT": "Submit"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Zadeva (samo e-pošta)",
          "PLACEHOLDER": "Neobvezna zadeva za e-poštne odgovore / nove pogovore"
        },
        "CONTENT": {
          "LABEL": "Sporočilo",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Priloge"
        },
        "INBOXES": {
          "LABEL": "Nabiralniki",
          "PLACEHOLDER": "Izberite nabiralnike (neobvezno, pustite prazno za vse nabiralnike)"
        },
        "SUBMIT": "Submit"
      },
      "BUTTON_TEXT": "Edit",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
      },
      "CONFIRM": {
        "TITLE": "Confirm deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
